import i18n from '@Lang'
import api from '@A'
import store from '@S'

const state = {
}

const mutations = {
}

const actions = {
  getApplicationList() {
    return new Promise((resolve, reject) => {
      api.application.list({ projectId: store.getters.currentProjectId }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getMetaData() {
    return new Promise((resolve, reject) => {
      api.metaData.list(store.getters.currentProjectId).then(res => {
        if (!res.data) {
          res.data = []
        }
        res.data = res.data.map(o => {
          return {
            label: o.anotherName || o.attributeName,
            value: o.attributeId,
            dataType: o.dataType,
            tooltip: o.description || o.attributeName
          }
        })
        const obj = res.data && res.data.length ? {
          label: i18n.t('analysis.defaultAttr'),
          groups: res.data || []
        } : null
        resolve(obj)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getPageAttribute({ commit }, appKey) {
    return new Promise((resolve, reject) => {
      api.pageAttribute.listByAppKey(appKey).then(res => {
        if (!res.data) {
          res.data = []
        }
        res.data = res.data.map(o => {
          return {
            label: o.anotherName || o.attributeName,
            value: `pageView.${o.attributeId}`,
            dataType: o.type,
            tooltip: o.attributeName
          }
        })
        const obj = res.data && res.data.length ? {
          label: i18n.t('analysis.pageAttr'),
          groups: res.data
        } : null
        resolve(obj)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getBusinessChannelList({ commit }, appKey) {
    return new Promise((resolve, reject) => {
      api.businessChannel.businessChannel.listByAppKey(appKey).then(res => {
        resolve(res.data || [])
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

